import { render, staticRenderFns } from "./EditDescuentoModal.vue?vue&type=template&id=16d4a756"
import script from "./EditDescuentoModal.vue?vue&type=script&lang=js"
export * from "./EditDescuentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports